import { render } from "./dealerstatementreport.vue?vue&type=template&id=6f68d8cc"
import script from "./dealerstatementreport.vue?vue&type=script&lang=js"
export * from "./dealerstatementreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__